import { cn } from '@shared/Frontend/utils/addToClassName'
import * as React from 'react'
import { StyleguideExample, StyleguidePart } from '../../../../../Shared/Hoppinger.Styleguide/Frontend'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ObjectsLayoutGrid = () => (
  <>
    <StyleguidePart title="Default" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ObjectLayoutGrid />
      </StyleguideExample>
    </StyleguidePart>
    <StyleguidePart title="Text-only" intro="Spans 8 columns on desktop. Used in Text block.">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ObjectLayoutGrid textOnly />
      </StyleguideExample>
    </StyleguidePart>
    <StyleguidePart title="With tail" intro="Used in Full-width Media block, which means there is no sidebar.">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ObjectLayoutGrid hasTail />
      </StyleguideExample>
    </StyleguidePart>
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ObjectLayoutGrid = (p: { textOnly?: boolean; hasTail?: boolean }) => {
  const elementStyle = { backgroundColor: 'antiquewhite' }
  const [showGuides, setShowGuides] = React.useState(false)
  const randomId = Math.random().toString(36).substring(2, 15)
  return (
    <div className="ls-container">
      <div>
        <input type="checkbox" id={randomId} checked={showGuides} onChange={() => setShowGuides(!showGuides)} />
        <label htmlFor={randomId}>Show layout guides</label>
      </div>
      <hr />

      <div className="ls-columns" style={{ position: 'relative' }}>
        {showGuides && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                'repeating-linear-gradient(90deg, rgb(0 0 0 / 20%), rgb(0 0 0 / 20%) 6.65%, transparent 6.65%, transparent 8.5%)',
            }}
          />
        )}

        <header className="ls-columns__header block__header" style={elementStyle}>
          <p className="">
            <code>.ls-columns__header</code>
            <br />
            <br />
            <br />
          </p>
        </header>

        <div
          className={cn(
            p.textOnly ? 'ls-columns__main-text' : p.hasTail ? 'ls-columns__main-wide' : 'ls-columns__main'
          )}
          style={elementStyle}
        >
          <p className="">
            <code>
              {p.textOnly ? '.ls-columns__main-text' : p.hasTail ? '.ls-columns__main-wide' : '.ls-columns__main'}
            </code>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </p>
        </div>

        <footer className="ls-columns__sidebar" style={elementStyle} hidden={p.hasTail}>
          <p className="">
            <code>.ls-columns__sidebar</code>
            <br />
            <br />
            <br />
          </p>
        </footer>

        <div className="ls-columns__tail" style={elementStyle} hidden={!p.hasTail}>
          <p className="">
            <code>.ls-columns__tail</code>
            <br />
          </p>
        </div>
      </div>
    </div>
  )
}
